import { styled } from '@mui/system';

export const Root = styled('section')({
  display: 'flex',
  flexDirection: 'column',
});
